import * as animation from "../animation";
import { biscReturnCode } from "../return-codes";
import { callBiscExtensions, getCardReaders } from "./meta";
import { getChallenge, postResponse } from "./authenticate";
import { log, logLevel } from "../logging";

async function forceCardInsertion() {
    if (animation.getInsertCardUserCancelled()) {
        log("[forceCardInsertion] The user canceled the operation", logLevel.Info);
        animation.resetAnimation();
        throw new Error(biscReturnCode.UserCancelled);
    }
    
    let readers = await getCardReaders();

    // no card reader attached
    if(readers.length < 1) {
        animation.showConnectReaderAnimation();
        return new Promise(resolve => {
           setTimeout(() => resolve(forceCardInsertion()), 400);
        });
    }

    for (let reader of readers) {
        if (reader.isabel_card_id) {
            return animation.resetAnimation();
        }
    }
    
    // no isabel card found in any of the readers
    animation.showInsertCardAnimation();
    return new Promise(resolve => {
        setTimeout(() => resolve(forceCardInsertion()), 400);
    });
}

export function isIsabelCardReaderAvailable() {
    return getCardReaders().then(card_readers => card_readers.filter(r => r.isabel_reader).length !== 0);
}

export function isIsabelCardAvailable() {
    //Call Bisc extensions
    return callBiscExtensions("isIsabelCardAvailable", resp => resp.available);
}

export async function isIsabelCardCertificateValid() {
    await forceCardInsertion();
    return callBiscExtensions("isIsabelCardCertificateValid", resp => resp.valid);
}

export async function getIsabelCardId() {
    await forceCardInsertion();
    return callBiscExtensions("isIsabelCardAvailable", resp => resp.isabel_card_id );
}

export async function isIsabelCardPinChanged() {
    await forceCardInsertion();
    return callBiscExtensions("isIsabelCardAvailable", resp => resp.card_pin_changed );
}

export async function getIsabelCardVersion(reader, cardid) {
    await forceCardInsertion();
    return callBiscExtensions("getIsabelCardVersion", resp => resp, {reader:reader, cardid: cardid});
}

async function signChallengeWithIsabelCard(challenge) {
    await forceCardInsertion();
    return callBiscExtensions("signChallengeWithIsabelCard", response => response.signature, {challenge:challenge});
}

export async function signEPaymentTokenWithIsabelCard(token) {
    return signChallengeWithIsabelCard(token);
}

export async function signAuthenticationChallengeWithIsabelCard(challenge) {
    return signChallengeWithIsabelCard(challenge);
}

export async function authenticateUserWithIsabelCard() {
    let challenge = await getChallenge();
    log("[authenticateUserWithIsabelCard] new challenge:\n" + challenge);
    let signature = await signChallengeWithIsabelCard(challenge)
    return postResponse(signature);
}